module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper builder-page",
    staticStyle: {
      "min-height": "calc(100vh - 101px)"
    }
  }, [_c('header', {
    staticClass: "builder-header"
  }, [_c('div', {
    staticClass: "builder-header__title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "builder-header__text"
  }, [_c('ol', {
    staticClass: "builder-crumbs"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/conversation/view"
    }
  }, [_vm._v("Conversations")])], 1), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.labelName))])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.currentJourneyData.name || _vm.labelName))])]), _vm._v(" "), _c('span', {
    staticClass: "builder-chip",
    class: {
      'builder-chip--edit': _vm.isEdit
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? 'Editing' : 'New'))])])]), _vm._v(" "), _c('section', {
    staticClass: "builder-body"
  }, [_c('div', {
    staticClass: "journey-main-container"
  }, [_c('conversation-tree-view', {
    attrs: {
      "conversationObject": _vm.currentJourneyData,
      "isJourneyConversation": false,
      "selectedStageName": ("" + (_vm.selectedStage ? _vm.selectedStage.stageName : 'uninitialized'))
    },
    on: {
      "nodeClick": _vm.nodeClicked,
      "editStage": function($event) {
        return _vm.handleEditStageClick({
          item: $event
        })
      },
      "validateConversation": _vm.validateConversation
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container__right"
  }, [(_vm.stageLoading) ? _c('div', {
    staticClass: "stage-switching"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('conversation', {
    ref: "conversation",
    attrs: {
      "stageToEdit": _vm.selectedStage,
      "isJourneyConversation": false,
      "metaData": _vm.metaData,
      "config": _vm.config,
      "folderName": _vm.folderName,
      "conversationName": _vm.currentJourneyData.name,
      "buttonDialog": _vm.buttonDialog,
      "isStageEdited": _vm.isStageEdited,
      "allConversations": _vm.allConversations
    },
    on: {
      "updateConfirmingSaveStage": _vm.updateConfirmingSaveStage,
      "stageReady": _vm.stageLoaded,
      "updateTree": _vm.updateTree
    }
  })], 1)], 1)]), _vm._v(" "), _c('vue-simple-context-menu', {
    ref: 'treeContextMenu',
    attrs: {
      "elementId": 'contextMenu',
      "options": _vm.options
    },
    on: {
      "option-clicked": _vm.optionClicked
    }
  }), _vm._v(" "), (_vm.processing) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "builder-header__icon"
  }, [_c('i', {
    staticClass: "fa fa-comments-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resizer",
    attrs: {
      "id": "resizeDragger",
      "title": "Drag to resize"
    }
  }, [_c('span', {
    staticClass: "resizer__grip"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "stage-switching__pill"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Loading stage…")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-161abd0f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/conversation/createOrUpdateConversation.vue
// module id = IvZe
// module chunks = 1